export default "__VITE_ASSET__DYTxiPCM__"